var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 0C77.6175 0 100 22.3825 100 50C100 77.6175 77.6175 100 50 100C22.3825 100 0 77.6175 0 50C0 22.3825 22.3825 0 50 0Z",
    fill: "#E60079"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0001 14.2144C57.131 14.2144 62.9026 17.5771 62.9026 21.7269C62.9026 25.8766 57.1191 29.2394 50.0001 29.2394C42.8692 29.2394 37.0977 25.8766 37.0977 21.7269C37.0977 17.5771 42.8811 14.2144 50.0001 14.2144Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0001 70.7729C57.131 70.7729 62.9026 74.1357 62.9026 78.2855C62.9026 82.4352 57.1191 85.798 50.0001 85.798C42.8692 85.798 37.0977 82.4352 37.0977 78.2855C37.0977 74.1357 42.8811 70.7729 50.0001 70.7729Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0069 32.1015C22.5724 25.9245 28.3678 22.6095 31.969 24.6843C35.5583 26.7592 35.5822 33.449 32.0167 39.614C28.4512 45.791 22.6559 49.106 19.0546 47.0311C15.4653 44.9562 15.4415 38.2665 19.0069 32.1015Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9913 60.3868C71.5568 54.2099 77.3521 50.8948 80.9414 52.9578C84.5308 55.0327 84.5546 61.7105 80.9891 67.8874C77.4237 74.0644 71.6283 77.3794 68.039 75.3165C64.4497 73.2416 64.4258 66.5638 67.9913 60.3868Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0546 52.9576C22.6439 50.8827 28.4512 54.2097 32.0167 60.3747C35.5822 66.5517 35.5583 73.2295 31.969 75.3044C28.3797 77.3793 22.5724 74.0523 19.0069 67.8872C15.4415 61.7103 15.4653 55.0325 19.0546 52.9576Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68.039 24.6841C71.6283 22.6092 77.4237 25.9361 80.9891 32.1131C84.5546 38.2901 84.5308 44.9679 80.9414 47.0428C77.3521 49.1176 71.5568 45.7907 67.9913 39.6137C64.4258 33.4367 64.4497 26.7589 68.039 24.6841Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDot);
export default __webpack_public_path__ + "static/media/DOT.26971b49d2aa83315ba41477c6726c86.svg";
export { ForwardRef as ReactComponent };